import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import type { AuthState, User } from '@/types';

// 使用新的 storage key，避免数据库重置/结构变更后旧 token 错位导致角色混乱
const AUTH_STORAGE_KEY = 'ai-grader-auth-v2';

// 登录态存 sessionStorage：每个标签页独立会话，避免多标签分别登录不同账号时
// 共享 localStorage 导致头像/身份串号（改头像会覆盖另一标签的登录态）。
// 刷新页面不丢失登录态；关闭标签页后需重新登录。
// 迁移：清理旧 localStorage 版本，避免与 sessionStorage 并存造成困惑。
try {
  window.localStorage.removeItem(AUTH_STORAGE_KEY);
} catch {
  // 忽略（隐私模式等场景下 localStorage 可能不可用）
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setAuth: (user: User, token: string) =>
        set({ user, token, isAuthenticated: true }),
      updateUser: (user: User) => set({ user }),
      clearAuth: () => set({ user: null, token: null, isAuthenticated: false }),
    }),
    {
      name: AUTH_STORAGE_KEY,
      // 每个标签页独立存储，互不覆盖
      storage: createJSONStorage(() => sessionStorage),
      // 持久化 token / user / isAuthenticated，避免刷新后被路由守卫踢回登录页
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    },
  ),
);
